import dayjs from 'dayjs'
import type { MerchantAgreementScheduleAValues } from './MerchantAgreementDocumentView'

interface MerchantAgreementScheduleAContext {
  agreementVersion: string
  merchantAccountId: string
  merchantLegalName: string
  authorizedUserName: string
  registeredEmail: string
  reusableAcceptanceId: string | null
  acceptedAt: number | null
}

const RECORDED_ON_ACCEPTANCE = 'Recorded by KyrenPay upon acceptance'
const STORED_IN_EXISTING_RECORD = 'Stored in the existing KyrenPay acceptance record'

export function buildMerchantAgreementScheduleA({
  agreementVersion,
  merchantAccountId,
  merchantLegalName,
  authorizedUserName,
  registeredEmail,
  reusableAcceptanceId,
  acceptedAt,
}: MerchantAgreementScheduleAContext): MerchantAgreementScheduleAValues {
  const reusingAcceptance = reusableAcceptanceId !== null

  return {
    'Agreement Version': agreementVersion,
    'Merchant Specific Terms Version / Reference': 'N/A',
    'Merchant Account ID': merchantAccountId,
    'Merchant Legal Name': merchantLegalName,
    'Authorized User': authorizedUserName,
    'Registered Email': registeredEmail,
    'Date and Time Accepted': acceptedAt
      ? dayjs(acceptedAt).format('YYYY-MM-DD HH:mm:ss Z')
      : reusingAcceptance ? STORED_IN_EXISTING_RECORD : RECORDED_ON_ACCEPTANCE,
    'IP Address': reusingAcceptance ? STORED_IN_EXISTING_RECORD : RECORDED_ON_ACCEPTANCE,
    'User Agent / Device Information': reusingAcceptance
      ? STORED_IN_EXISTING_RECORD
      : typeof window === 'undefined' ? RECORDED_ON_ACCEPTANCE : window.navigator.userAgent,
  }
}
